module.exports = __webpack_public_path__ + "img/welcome-img.4d4a451f.png";